import {
  ContactToScheduleApplyTargetFacility,
  isContactToScheduleApplyTarget,
} from '@/service/parentContacts/isContactToScheduleApplyTarget';
import { isContactToScheduleApplyFlagPathOpen } from '@/service/parentContacts/isContactToScheduleApplyFlagPathOpen';

export const isContactToScheduleApplyEnabled = async (
  services?: ContactToScheduleApplyTargetFacility
): Promise<boolean> => {
  if (!isContactToScheduleApplyTarget(services)) {
    return false;
  }

  return isContactToScheduleApplyFlagPathOpen();
};
